export default "__VITE_ASSET__CamHfBjz__"